/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react'


import { ListButtonsPagination } from './styles'

interface IProps {
    total: number
    offset: number
    setOffset: (k: number) => void
    limit: ISelect
    setLimit: (k: ISelect) => void
    setPage?: (k: number) => void
}

interface ISelect {
    value: number
    label: string
}

export const ReportPagination: React.FC<IProps> = ({ total, offset, setOffset, limit, setPage }) => {
    const maxItems = 5
    const maxLeft = (maxItems - 1) / 2
    const current = offset ? offset / limit.value + 1 : 1
    const pages = Math.ceil(total / limit.value)
    const first = Math.max(current - maxLeft, 1)

    function onPageChange(page): void {
        setOffset((page - 1) * limit.value)
        setPage(page)
    }

    useEffect(() => {
        setOffset(0)
    }, [limit.value, setOffset, total])

    return (
        <ListButtonsPagination>
            <li>
                <button onClick={() => onPageChange(current - 1)} disabled={current === 1}>
                    <i className="fas fa-chevron-left"></i>
                </button>
            </li>
            {Array.from({ length: Math.min(maxItems, pages) })
                .map((_, index) => index + first)
                .map(page => {
                    if (page <= pages) {
                        return (
                            <li key={page}>
                                <button
                                    className={page === current && 'active-page'}
                                    onClick={() => onPageChange(page)}
                                >
                                    {page}
                                </button>
                            </li>
                        )
                    }
                })}
            {current <= pages - (maxLeft + 1) && pages > maxItems && (
                <>
                    <div className="reticence">
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                    </div>
                    <li>
                        <button onClick={() => onPageChange(pages)}>{pages}</button>
                    </li>
                </>
            )}
            <li>
                <button onClick={() => onPageChange(current + 1)} disabled={current === pages}>
                    <i className="fas fa-chevron-right"></i>
                </button>
            </li>
        </ListButtonsPagination>
    )
}
